

import { Link } from "react-router-dom";

import EVENTS_DATA from '../data/EVENT_DATA'

export default function Events() {
    console.log( EVENTS_DATA ) 
    return (

        <div>
        <h1>Blog</h1>
  
        <ul>
          {EVENTS_DATA._key_arr.map( _key => {

            console.log(_key)

            return (
            <li key={ EVENTS_DATA[_key].id }>
              <Link to={`/blog/${ EVENTS_DATA[_key].slug }`}>
                { EVENTS_DATA[_key].title }
              </Link>
            </li>
          )}
          )}
        </ul>

      </div>
    );
  }
  
  
  
  
  